import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import { GeneralData } from './sections/GeneralData/GeneralData.tsx';
import { GeneralDataTable } from './sections/GeneralDataTable/GeneralDataTable.tsx';
import { RateComparsionChart } from './sections/RateComparsionChart/RateComparsionChart.tsx';
import { SpendChart } from './sections/SpendChart/SpendChart.tsx';

export const DealInsightsGeneral = () => {
  return (
    <Box
      component="section"
      data-test="deal-insights-general"
      sx={{
        pt: 4,
        px: 4,
      }}
    >
      <GeneralData />
      <Divider sx={{ mx: -4 }} />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          flex: 1,
        }}
        data-test="charts-container"
      >
        <SpendChart />
        <Divider orientation="vertical" flexItem />
        <RateComparsionChart />
      </Box>
      <Divider sx={{ mx: -4 }} />
      <Box
        sx={{
          mx: -4,
        }}
      >
        <GeneralDataTable />
      </Box>
    </Box>
  );
};
